import IMCore, { NWOption } from "@/sdk/IMCore";

export default class NW extends IMCore {
  constructor(props: NWOption) {
    super(props);
  }

  /**
   * 呼叫用户
   * @param to 被呼叫的用户ID
   */
  callVideo(to: string) {
    return this.control("callVideo", {
      to
    });
  }

  /**
   * 同意视频呼叫
   * @param to 对方ID
   * @param meetingId  会议ID
   */
  acceptVideo(to: string, meetingId: string) {
    return this.control("acceptVideo", {
      to,
      content: {
        meetingId
      }
    });
  }

  /**
   * 挂断视频呼叫
   * @param to
   */
  hangupVideo(to: string) {
    return this.control("hangupVideo", {
      to
    });
  }

  /**
   * 拒绝视频呼叫
   * @param to
   */
  refuseVideo(to: string) {
    return this.control("refuseVideo", { to });
  }

  /**
   * 呼叫用户
   * @param to 被呼叫的用户ID
   */
  callAudio(to: string) {
    return this.control("callAudio", {
      to
    });
  }

  /**
   * 同意语音呼叫
   * @param to 对方ID
   * @param meetingId  会议ID
   */
  acceptAudio(to: string, meetingId: string) {
    return this.control("acceptAudio", {
      to,
      content: {
        meetingId
      }
    });
  }

  /**
   * 挂断语音呼叫
   * @param to
   */
  hangupAudio(to: string) {
    return this.control("hangupAudio", {
      to
    });
  }

  /**
   * 拒绝语音呼叫
   * @param to
   */
  refuseAudio(to: string) {
    return this.control("refuseAudio", { to });
  }

  /**
   * 呼叫用户
   * @param to 被呼叫的用户ID
   */
   callShare(to: string) {
    return this.control("callShare", {
      to
    });
  }

  /**
   * 同意视频呼叫
   * @param to 对方ID
   * @param meetingId  会议ID
   */
  acceptShare(to: string, meetingId: string) {
    return this.control("acceptShare", {
      to,
      content: {
        meetingId
      }
    });
  }

  /**
   * 挂断视频呼叫
   * @param to
   */
  hangupShare(to: string) {
    return this.control("hangupShare", {
      to
    });
  }

  /**
   * 拒绝视频呼叫
   * @param to
   */
  refuseShare(to: string) {
    return this.control("refuseShare", { to });
  }


  /**
   * 打开摄像头
   */
  openCamera = () => {
    return this.coolVideo.dtmf("*1");
  };
  /**
   *  关闭摄像头
   */
  closeCamera = () => {
    return this.coolVideo.dtmf("*0");
  };

  /**
   * 打开麦克风
   */
  openMic = () => {
    return this.coolVideo.dtmf("1");
  };
  /**
   * 关闭麦克风
   */
  closeMic = () => {
    return this.coolVideo.dtmf("0");
  };
}
